import ListAltIcon from '@material-ui/icons/ShortText';

const PlumbingReviewerSubitem = () => {
  const links = {
    subheader: 'Plumbing Reviewer Submenu',
    owner: 'plumbing-reviewer',
    items: [
      {
        title: 'Processed Permits',
        icon: ListAltIcon,
        href: '/plumbing-reviewer/reviewed/request/permit/approved-list',
        enabled: true
      },

      {
        title: 'Processed Permits For Occupancy',
        icon: ListAltIcon,
        href:
          '/plumbing-reviewer/reviewed/request/occupancy/permit/approved-list',
        enabled: true
      }
    ]
  };

  return links;
};

export default PlumbingReviewerSubitem;
